import {observer} from "mobx-react";
import {FieldAutoComplete, FieldSelect} from "../../ui";
import {slsCustomerCabinetStore, SlsPrinterItem, slsPrinterStore} from "../../../store";

interface FormValue {
    printer: SlsPrinterItem | undefined
    cabinet: string | undefined
}

interface SlsProcessCompleteFormProps {
    value: FormValue
    onChange: (value: FormValue) => any
}


const SlsProcessCompleteForm = observer(function SlsProcessCompleteForm({
                                                                            value,
                                                                            onChange
                                                                        }: SlsProcessCompleteFormProps) {
    const cabinetsExist = slsCustomerCabinetStore.cabinets.length > 0

    return <>
        <div className={'columns'}>
            {cabinetsExist && <div className={'column is-half'}>
                <FieldSelect
                    label={"Schrank"}
                    help={"Bitte wähle den zu verwendenden Schrank"}
                    options={slsCustomerCabinetStore.cabinetsAsOption}
                    value={value.cabinet || ''}
                    onChange={v => {
                        onChange({
                            ...value,
                            cabinet: v || undefined
                        })
                    }}
                />
            </div>}
            <div className={`column ${cabinetsExist ? 'is-half' : 'is-full'}`}>
                <FieldAutoComplete
                    label={"Labeldrucker"}
                    help={"Bitte wähle den zu verwendenden Drucker"}
                    required={true}
                    itemRenderer={c => c.label}
                    options={slsPrinterStore.options}
                    search={async (v) => {
                        await slsPrinterStore.find(v)
                        return slsPrinterStore.options
                    }}
                    value={value.printer}
                    onChange={v => {
                        onChange({
                            ...value,
                            printer: v
                        })
                    }}
                />
            </div>
        </div>
    </>
})
export {
    SlsProcessCompleteForm
}
